import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Profile from "@pages/Account/Profile";
import Settings from "@pages/Account/Settings";
import CogsLocationBreakdown from "@pages/CogsLocationBreakdown";
import CheckDashboard from "@pages/Dashboard/CheckDashboard";
import CloseCheckTable from "@pages/Dashboard/CheckDashboard/CheckTable/CloseCheckTable";
import OpenCheckTable from "@pages/Dashboard/CheckDashboard/CheckTable/OpenCheckTable";
import SingleCheckDisplay from "@pages/Dashboard/CheckDashboard/SingleCheckDisplay";
import CogsDashBoard from "@pages/Dashboard/CogsDashboard";
import HomeDashboard from "@pages/Dashboard/HomeDashboard";
import LabourDashboard from "@pages/Dashboard/LabourDashboard";
import Notification from "@pages/Dashboard/Notification";
import RevenueDashBoard from "@pages/Dashboard/RevenueDashBoard";
import EmployeePayAll from "@pages/EmployeePay";
import HistoricalReports from "@pages/HistoricalReports";
import LabourBreakdown from "@pages/LabourBreakdown";
import NotFound from "@pages/NotFound";
import CogsProductMixBreakdownAllItems from "@pages/ProductMixBreakdownAllItems";
import SalesBreakdown from "@pages/SalesBreakdown";
import ShiftInformationAll from "@pages/ShiftInformation";
import DefaultLayout from "@shared-layouts/DefaultLayout";
import SignInPage from "@shared-layouts/SignInPage";
import LoginFailed from "@shared-layouts/SignInPage/LoginFailed";
import LoginSuccess from "@shared-layouts/SignInPage/LoginSuccess";
import { HistoricalReportRoute } from "@src/constants";
import Locations from "@src/pages/Administration/Locations";

const router = createBrowserRouter(
  [
    { path: "/login", element: <SignInPage /> },
    { path: "/success-login", element: <LoginSuccess /> },
    { path: "/fail-login", element: <LoginFailed /> },
    {
      path: "/",
      element: <DefaultLayout />,
      children: [
        { path: "/", element: <HomeDashboard /> },
        { path: HistoricalReportRoute, element: <HistoricalReports /> },
        { path: "/notification-center", element: <Notification /> },
        { path: "/profile", element: <Profile /> },
        { path: "/revenue-dashboard", element: <RevenueDashBoard /> },
        { path: "/cogs-dashboard", element: <CogsDashBoard /> },
        { path: "/labour-dashboard", element: <LabourDashboard /> },
        {
          path: "/labour-dashboard/labour-breakdown",
          element: <LabourBreakdown />,
        },
        {
          path: "/labour-dashboard/employee-pay",
          element: <EmployeePayAll />,
        },
        {
          path: "/labour-dashboard/shift-information",
          element: <ShiftInformationAll />,
        },
        {
          path: "/revenue-dashboard/sales-breakdown",
          element: <SalesBreakdown />,
        },
        {
          path: "/cogs-dashboard/cogs-breakdown",
          element: <CogsLocationBreakdown />,
        },
        {
          path: "/revenue-dashboard/product-mix-breakdown",
          element: <CogsProductMixBreakdownAllItems />,
        },
        {
          path: "/cogs-dashboard/product-mix-breakdown",
          element: <CogsProductMixBreakdownAllItems />,
        },
        { path: "/check-information", element: <CheckDashboard /> },
        {
          path: "/check-information/open-checks",
          element: <OpenCheckTable pagination />,
        },
        {
          path: "/check-information/closed-checks",
          element: <CloseCheckTable pagination />,
        },
        {
          path: "/check-information/open-checks/:propertyShortName/:checkNumber",
          element: <SingleCheckDisplay />,
        },
        {
          path: "/check-information/closed-checks/:propertyShortName/:checkNumber",
          element: <SingleCheckDisplay />,
        },
        {
          path: "/check-information/:propertyShortName/:checkNumber",
          element: <SingleCheckDisplay />,
        },
        {
          path: "/notification-center/:propertyShortName/:checkNumber/:notificationId",
          element: <SingleCheckDisplay />,
        },
        {
          path: "/settings",
          element: <Settings />,
        },
        {
          path: "/locations",
          element: <Locations />,
        },
      ],
    },

    { path: "*", element: <NotFound /> },
  ],
  { basename: "/" }
);

function AppRoutes() {
  return <RouterProvider router={router} />;
}

export default AppRoutes;
